import { useLocation } from 'react-router';
import { GraphNavigationState } from './use-graph-navigation';

export const useGraphLocation = () => {
  return useLocation() as { state?: GraphNavigationState };
};
